import { AppContainer, Typography } from '@p2p/components';

import styles from './ErrorPage.module.scss';
import { ErrorPageProps } from './ErrorPage.types';

export const ErrorPage = ({ title, description, icon }: ErrorPageProps) => {
  return (
    <AppContainer>
      <div className={styles.container}>
        <div className={styles.content}>
          <div className={styles.iconContainer}>{icon}</div>
          <Typography variant="h1" className={styles.title} color="heading">
            {title}
          </Typography>
          <Typography variant="text-l-medium" className={styles.description}>
            {description}
          </Typography>
        </div>
      </div>
    </AppContainer>
  );
};
